import { Message } from '@patsnap/tahiti-core/common/message';
import { isPsHttpError } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ErrorHandlerContribution, ErrorHandlerRegistry } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { I18nService } from '@/services/i18n-service';
import { invokeEditionUpgrade, prepareInterceptorEdition } from '@eureka/edition-upgrade';
import { HttpSuccessException } from '@eureka/services/src/exception';
import { UsageAmountWhere } from '@eureka/edition-upgrade/src/constants';

@injectable()
export class ProjectErrorHandler implements ErrorHandlerContribution {
    constructor(
        @inject(Message)
        private readonly _message: Message,
        @inject(I18nService)
        private readonly _i18nService: I18nService
    ) { }

    private _showErrorMessageByCode(code: number) {
        const message = this._i18nService.t(`commonStatusCode.${code || '400'}`)
        if (message) {
            this._message.error({
                message,
            });
            return true;
        }
        return false;
    }

    registerHandler(handlers: ErrorHandlerRegistry): void {
        handlers.register((error: Error) => {
            const data = error.cause || error.data;
            if (prepareInterceptorEdition(data.error_code)) {
                invokeEditionUpgrade(UsageAmountWhere.TECH_RESEARCH).then((needToast) => {
                    needToast && this._showErrorMessageByCode(data.error_code);
                });
                return true;
            }
            return false;
        });

        handlers.register((error: Error) => {
            if (!HttpSuccessException.is(error)) {
                return false;
            }
            const data = error.data;
            return this._showErrorMessageByCode(data.error_code);
        });

        handlers.register((error: Error) => {
            if (!isPsHttpError(error)) {
                return false;
            }
            const data = error.cause;
            return this._showErrorMessageByCode(data.error_code);
        });
    }
}
